import { useQuery } from '@tanstack/react-query';

import { useQueryHTTPRequest } from 'api/hooks/useHTTPRequest';

import { Sprint } from 'features/sprint';
import { QUERY_KEYS, URLS } from 'features/sprint/config';
import { useSprintType } from 'features/sprint/hooks/useSprintType';

const useSprintQuery = ({ sprintId, options }) => {
  const sprintType = useSprintType();
  const { request } = useQueryHTTPRequest();

  return useQuery(
    QUERY_KEYS.SPRINT(sprintId),
    () => request({ url: URLS.SPRINT(sprintId) }),
    {
      select: (sprint) => {
        return new Sprint({ ...sprint, type: sprintType });
      },
      ...options,
    }
  );
};

export default useSprintQuery;
